export default __webpack_public_path__ + "media/portrait/logo_chanel-c5578419.svg";